import { AuthService } from './../../core/services/auth-service/auth.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CChangePassoword } from './../../core/models/login';
import {
  changePasswordSuccess,
  passwordsCompare,
  serverError,
  oldEmail, oldPassword
} from './../../core/models/messages';
import { MustMatch } from './../../core/models/must-match-validator';
import { patternEmail, patternPassword } from './../../core/models/pattern';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { LocalStorageService } from '@core/services/local-storage.service';
import { FournisseurService } from '@core/services/fournisseur-service/fournisseur.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
})
export class ChangePasswordComponent {
    /* generate email control */
    currentUser = this.localStorageService.getData('UserInfo');
  EmailForm: FormGroup = this.emailForm();
  validateEmailForm: FormGroup = this.createValidateEmailForm();
   /* formGroup */
   generateResePasswordForm: FormGroup = this.resetPasswordForm(
    new CChangePassoword()
  );
  passwordDeactivateForm: FormGroup = this.createPasswordDeactivateForm();
  passwordDeleteForm: FormGroup = this.createPasswordDeleteForm();
  /* boolean */
  loadSpinner: boolean = false;
  /* formGroup */
  changePasswordForm: FormGroup = this.createChangePasswordForm(
    new CChangePassoword()
  );
  
  showPasswordConfirmation: boolean = false;
  showOldPassword: boolean = false;
  showConfirmedNewPassword: boolean = false;
  
  userEmail!: string;
  showPassword:  boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: string = 'password';
  passwordsCompareMessage: string = '';
  tabIndex: number = 1;
  emailError: boolean = false;
  IsChangeEmailStep2 : boolean = false;
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private authService: AuthService,
    private localStorageService: LocalStorageService,
     private companyService:FournisseurService,
     private spinner: NgxSpinnerService,
  ) {}

  ngOnInit() {
  }
  togglePasswordVisibility(field: string) {
    if (field === 'newPassword') {
      this.showNewPassword = !this.showNewPassword;
    } else if (field === 'oldPassword') {
      this.showOldPassword = !this.showOldPassword;
    } else if (field === 'ConfirmedNewPassword') {
      this.showConfirmedNewPassword = !this.showConfirmedNewPassword;
    } else if (field === 'passwordConfirmation') {
      this.showPasswordConfirmation = !this.showPasswordConfirmation;
    }
  }
  
  deactivateOrDeleteAccount(enable : number) {

    let  password = null
    if (enable === 0) {
      if (this.passwordDeactivateForm.invalid) return
      password = this.passwordDeactivateForm.get('password')?.value;

    } else if (enable === 2) {
      if (this.passwordDeleteForm.invalid) return
      password = this.passwordDeleteForm.get('password')?.value;
    }

    this.spinner.show();
        this.authService
          .deactivateAccount({password, enable})
          .pipe()
          .subscribe({
            next: (res) => {
              this.spinner.hide();
              if (res.status == 200) {
                if(enable === 0) {
                  this.toastrService.success('Votre compte a été désactivé avec succès.');
                } else if(enable === 2) {
                  this.toastrService.success('Votre compte a été supprimé avec succès.');
                }
                this.authService.logOut();
              }
            },
            error: (err: any) => {
              this.spinner.hide();
              if (err.error) {
                this.toastrService.error(
                  err.error.status === 400 &&  err.error.message === "Incorrect password" ? 
                  "Votre mot de passe est incorrect" : serverError
                );
              }
            },
          });
      }
  emailForm() {

    return this.formBuilder.group({
      old_email: [{ value: JSON.parse(this.currentUser!).email, disabled: true }
        ,
        [
          Validators.required,
          Validators.email,
          Validators.pattern(patternEmail),
        ],
      ],
      new_email: [''
        ,
        [
          Validators.required,
          Validators.email,
          Validators.pattern(patternEmail),
        ],
      ],
      password: [
        '',
        [Validators.required, Validators.pattern(patternPassword)],
      ],
    });
  }

  createValidateEmailForm() {
    return this.formBuilder.group({
      number1: ['', Validators.required],
      number2: ['', Validators.required],
      number3: ['', Validators.required],
      number4: ['', Validators.required],
    });
  }
  checkEmailMatch() {
    const newEmail = this.EmailForm.get('new_email')?.value;
    const oldEmail = this.EmailForm.get('old_email')?.value;

    if (newEmail && newEmail === oldEmail) {
      this.emailError = true;
    } else {
      this.emailError = false;
    }
  }
    MailChange() {
      if (this.EmailForm.valid) {
        this.spinner.show();
        this.loadSpinner = true;
        const data ={
          new_email: this.EmailForm?.get('new_email')?.value,
          password: this.EmailForm?.get('password')?.value,
  
        }
        this.companyService
          .changeEmail(data)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res: { status: number; data: any }) => {
              if (res.status == 200) {
                this.loadSpinner = true;
                this.IsChangeEmailStep2 = true;
                this.spinner.hide();
              }
            },
            error: (err: any) => {
              this.spinner.hide();
              this.loadSpinner = false;
              if (err.error.message == "Old password is incorrect") {
                this.toastrService.error(oldPassword);
              }
              if (err.error.message?.new_email[0] == "The new_email has already been taken.") {
                this.toastrService.error(oldEmail);
              }
            
            },
          });
      }
    }

    validateChangeMail() {
      if( this.validateEmailForm.valid) {
        this.spinner.show();
        this.loadSpinner = true;
        let codeReset = Object.values(this.validateEmailForm.value).join('');
        this.companyService
          .validateChangeEmail({ validation_code: codeReset })
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res: { status: number; data: any }) => {
              if (res.status == 200) {
                this.loadSpinner = false;
                this.spinner.hide();
                this.authService.logOut()
              }
            },
            error: (err: any) => {
              this.spinner.hide();
              this.loadSpinner = false;
              this.toastrService.error("Le code de validation est incorrect ou expiré.");
              this.IsChangeEmailStep2 = false;
              this.validateEmailForm.reset();
              this.EmailForm.reset();
              this.EmailForm.patchValue({
                old_email: JSON.parse(this.currentUser!).email,
              });
            }
          });
      }
    }
  /* create resetPassword form */
  createChangePasswordForm(data: CChangePassoword) {
    return this.formBuilder.group(
      {
        oldPassword: [
          data.oldPassword,
          [Validators.required, Validators.pattern(patternPassword)],
        ],
        newPassword: [
          data.newPassword,
          [Validators.required, Validators.pattern(patternPassword)],
        ],
        confirmNewPassword: [
          data.confirmNewPassword,
          [Validators.required, Validators.pattern(patternPassword)],
        ],
      },
      {
        validator: MustMatch('newPassword', 'confirmNewPassword'),
      }
    );
  }
 /* create resetPassword form */
 resetPasswordForm(data: CChangePassoword) {
  return this.formBuilder.group(
    {
      oldPassword: [
        data.oldPassword,
        [Validators.required, Validators.pattern(patternPassword)],
      ],
      newPassword: [
        data.newPassword,
        [Validators.required, Validators.pattern(patternPassword)],
      ],
      confirmNewPassword: [
        data.confirmNewPassword,
        [Validators.required, Validators.pattern(patternPassword)],
      ],
    },
    {
      validator: MustMatch('newPassword', 'confirmNewPassword'),
    }
  );
}
createPasswordDeactivateForm(data?: any) {
  return this.formBuilder.group(
    {
      password: ['' , [Validators.required, Validators.pattern(patternPassword)]],
    }
  );
}
createPasswordDeleteForm(data?: any) {
  return this.formBuilder.group(
    {
      password: ['' , [Validators.required, Validators.pattern(patternPassword)]],
    }
  );
}
  changeTab(tab: number) {
    if(this.tabIndex === tab) return
      this.tabIndex = tab;
      this.generateResePasswordForm.reset()
      this.passwordDeactivateForm.reset()
      this.passwordDeleteForm.reset()
      this.showPasswordConfirmation = false;
      this.showOldPassword = false;
      this.showNewPassword = false;
      this.showConfirmedNewPassword = false;
    }
    /* reset password */
  resetPassword() {
    if (this.generateResePasswordForm.valid) {
      const oldPassword =
        this.generateResePasswordForm.get('oldPassword')?.value;
      const newPassword =
        this.generateResePasswordForm.get('newPassword')?.value;

      // Compare old and new passwords
      if (oldPassword === newPassword) {
        this.toastrService.error();
      } else {
        const data = {
          oldPassword: oldPassword,
          newPassword: newPassword,
        };

        this.spinner.show();
        this.authService
          .changePassword(data)
          .pipe()
          .subscribe({
            next: (res) => {
              if (res.status == 200) {
                this.spinner.hide();
                this.toastrService.success(changePasswordSuccess);
                this.authService.logOut();
              }
            },
            error: (err: any) => {
              this.spinner.hide();
              if (err.error) {
                this.toastrService.error(
                  err.error.status === 403 ? oldPassword : serverError
                );
              }
            },
          });
      }
    }
  }
  onRightClick(event: MouseEvent) {
    event.preventDefault(); // Empêche le menu contextuel par défaut
  }
  /* reset password */

  changePassword() {
    this.passwordsCompareMessage = '';
    if (this.changePasswordForm.valid) {
      if (
        this.changePasswordForm.get('oldPassword')?.value ==
        this.changePasswordForm.get('newPassword')?.value
      ) {
        this.passwordsCompareMessage = passwordsCompare;
        this.toastrService.error(passwordsCompare);
      } else {
        const data = {
          oldPassword: this.changePasswordForm.get('oldPassword')?.value,
          newPassword: this.changePasswordForm.get('newPassword')?.value,
        };
        this.loadSpinner = true;
        this.spinner.show();
        this.authService
          .changePassword(data)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res) => {
              if (res.status == 200) {
                this.spinner.hide();
                this.loadSpinner = false;
                this.toastrService.success(changePasswordSuccess);
                this.authService.logOut();
              }
            },
            error: (err: Error) => {
              this.spinner.hide();
              this.loadSpinner = false;
              this.toastrService.error(serverError);
            },
          });
      }
    }
  }
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
